// Event type & mode metadata (single source of truth).
export const EVENT_TYPES = [
  { key: "katha", deva: "कथा", en: "Katha", accent: "#C75000" },
  { key: "yagya", deva: "यज्ञ", en: "Yagya", accent: "#B45309" },
  { key: "festival", deva: "उत्सव", en: "Festival", accent: "#A21CAF" },
  { key: "talk", deva: "प्रवचन", en: "Talk", accent: "#1D4ED8" },
  { key: "other", deva: "अन्य", en: "Other", accent: "#57534E" },
];

export const eventTypeMeta = (k) => EVENT_TYPES.find((t) => t.key === k) || EVENT_TYPES[4];

export const formatEventDate = (iso, en = true) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" };
  const date = d.toLocaleDateString(en ? "en-IN" : "hi-IN", opts);
  const hasTime = iso.includes("T") && !iso.endsWith("T00:00:00") && d.getHours() + d.getMinutes() > 0;
  const time = hasTime ? d.toLocaleTimeString(en ? "en-IN" : "hi-IN", { hour: "numeric", minute: "2-digit" }) : "";
  return time ? `${date} · ${time}` : date;
};

export const eventDayParts = (iso) => {
  if (!iso) return { day: "", mon: "" };
  const d = new Date(iso);
  if (isNaN(d)) return { day: "", mon: "" };
  return { day: d.getDate(), mon: d.toLocaleDateString("en-IN", { month: "short" }) };
};
